(function () {
  function replaceHeading(heading) {
    var replacement = document.createElement('h2');
    Array.prototype.slice.call(heading.attributes).forEach(function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    while (heading.firstChild) replacement.appendChild(heading.firstChild);
    heading.replaceWith(replacement);
  }

  function normalizeKlaviyoHeadings(root) {
    if (!(root instanceof Element)) return;

    if (root.matches('.klaviyo-form-richtext > h1')) replaceHeading(root);
    root.querySelectorAll('.klaviyo-form-richtext > h1').forEach(replaceHeading);
  }

  function initialize() {
    normalizeKlaviyoHeadings(document.body);

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(normalizeKlaviyoHeadings);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
